var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 48,
    stroke: "#FF9900",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69 36.2093V66.8056C69 68.1833 68.4609 69.5042 67.5016 70.4782C66.5422 71.4521 65.2413 71.9996 63.8845 71.9996H60.0627L60.0629 72H52.1589C52.1592 71.9999 52.1595 71.9998 52.1597 71.9996C53.9518 71.1938 55.2941 69.5448 55.6982 67.5482C55.6982 67.5481 55.6983 67.548 55.6983 67.5478H63.8845C64.0787 67.5478 64.2642 67.4697 64.4013 67.3305C64.5384 67.1913 64.6154 67.0029 64.6154 66.8057V39.3546H55.8464V30.4516H36.1157C35.712 30.4516 35.3848 30.7839 35.3848 31.1938V66.8061C35.3848 67.216 35.712 67.5482 36.1157 67.5482H43.6419C44.0461 69.5451 45.3887 71.1943 47.1812 72H36.1157C34.7587 72 33.4579 71.4525 32.4986 70.4785C31.5393 69.5045 31 68.1837 31 66.8061V31.1939C31 29.8161 31.5393 28.4955 32.4986 27.5215C33.458 26.5475 34.7589 26 36.1157 26H58.9443L69 36.2093Z",
    fill: "#FF9900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4588 68.1405C46.8723 67.5162 46.5801 66.7492 46.5801 65.8634C46.5801 64.9557 46.8701 64.1792 47.4617 63.5639C48.0707 62.9301 48.866 62.6235 49.8101 62.6235C50.7632 62.6235 51.5607 62.9286 52.1599 63.5654C52.7506 64.1805 53.0401 64.9564 53.0401 65.8634C53.0401 66.7492 52.7479 67.5162 52.1614 68.1405C51.562 68.7785 50.764 69.0841 49.8101 69.0841C48.866 69.0841 48.0707 68.7774 47.4617 68.1436L47.4588 68.1405Z",
    fill: "#FF9900"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0237 41.7986V57.4433C52.0237 58.7328 50.9784 59.7781 49.6889 59.7781C48.3995 59.7781 47.3542 58.7328 47.3542 57.4433V41.7986C47.3542 40.5092 48.3995 39.4639 49.6889 39.4639C50.9784 39.4639 52.0237 40.5092 52.0237 41.7986Z",
    fill: "#FF9900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.cbf4b220de4c25cde1340999e0be390e.svg";
export { ForwardRef as ReactComponent };